<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
// A list whose create/edit form is a drawer opened by the route (macros, teams: R2-9-6) keeps one instance for
// the list and its drawer routes (`meta.keepAliveKey`), so opening the drawer does not remount the list.
const pageKey = computed(() => route.meta.keepAliveKey ?? route.fullPath);
// A page about one record (an inbox, an integration: `meta.keepAlive: false`) is not kept. Kept, it went on
// re-rendering against the routes that came after it (the next page's params, "title"/"integrationId" undefined)
// and left one cached copy per address visited. It is drawn beside the cache, so the lists stay cached.
const isCached = computed(() => route.meta.keepAlive !== false);
</script>

<!-- The frame of every settings page (phase 9.1, the kit's SettingsArea): full height, no narrow column.
     A page on the kit's mould (SettingsLayout, `data-settings-layout`) fills it, keeps its header still and scrolls
     its own content. A page not on the mould yet gets the kit's padding and width here and scrolls as a whole. -->
<template>
  <div
    class="flex h-full min-h-0 w-full flex-col overflow-auto bg-n-surface-1 text-polaris-foreground"
  >
    <div
      class="mx-auto flex w-full max-w-[100rem] flex-col px-6 py-6 has-[>[data-settings-layout]]:min-h-0 has-[>[data-settings-layout]]:max-w-none has-[>[data-settings-layout]]:flex-1 has-[>[data-settings-layout]]:p-0"
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" v-if="isCached" :key="pageKey" />
        </keep-alive>
        <component
          :is="Component"
          v-if="!keepAlive || !isCached"
          :key="pageKey"
        />
      </router-view>
    </div>
  </div>
</template>
